import ValidatedIcon from '../../assets/ValidateIcon.png';
import { PatientPageLayout } from '@/components/PatientPageLayout';
import { useSelectedPatient } from '../../hooks/patient.hooks';

export const UnsubscribeValidation = () => {
  const { data: patient } = useSelectedPatient();
  const unsubscribeFromSMS = patient?.unsubscribedFromSMS;
  const unsubscribeFromEmails = patient?.unsubscribedFromEmails;
  const sex = patient?.sex;

  return (
    <div className="h-full flex flex-col px-4 n2xs:px-6 nsm:px-0">
      <PatientPageLayout
        title={
          <>
            <h1 className="text-2xl min-[23rem]:text-3.5xl font-semibold leading-tight text-center">
              {sex === 'FEMALE'
                ? 'Vous êtes désinscrite'
                : 'Vous êtes désinscrit'}
            </h1>
          </>
        }
        footer={<></>}
      >
        <div className="flex flex-col justify-center items-center gap-6 nxs:text-center">
          <img src={ValidatedIcon} alt="Validated" className="w-20 h-20" />

          <p className="font-light">
            Vous ne recevrez plus de{' '}
            {unsubscribeFromSMS && unsubscribeFromEmails
              ? "SMS  ni d'e-mails"
              : unsubscribeFromSMS
              ? 'SMS'
              : 'e-mails'}{' '}
            concernant ce médecin.
          </p>

          <p className="font-light">
            Si vous souhaitez à nouveau participer au questionnaire Aldebaran,
            indiquez-le directement à votre médecin.
          </p>
        </div>
      </PatientPageLayout>
    </div>
  );
};
